import { render, staticRenderFns } from "./BoxMap.vue?vue&type=template&id=52f94c18"
import script from "./BoxMap.vue?vue&type=script&lang=js"
export * from "./BoxMap.vue?vue&type=script&lang=js"
import style0 from "./BoxMap.vue?vue&type=style&index=0&id=52f94c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports